export enum HotKeyActionId {
  Rename = 'fileDialog.rename',
  MoveToIncoming = 'fileDialog.moveToIncoming',
  MoveToOutgoing = 'fileDialog.moveToOutgoing',
  MoveFiles = 'files.move',
  Close = 'dialog.close',
  ArrowLeft = 'files.arrowLeft',
  ArrowRight = 'files.arrowRight',
}

export interface HotKeyAction {
  id: HotKeyActionId;
  key: string;
  label: string;
  description: string;
  group: string;
  showInTooltip: boolean;
}

export interface HotKeyHandler {
  actionId: string;
  handler: () => void;
}

export type HandlerFunction = () => void;

export interface HotKeyContext {
  registerHandler: (handler: HotKeyHandler) => void;
  unregisterHandler: (actionId: string) => void;
  setupHotKeys: () => void;
  cleanupHotKeys: () => void;
}
